import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { ItfItem, ItfItemBtn } from './type';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect } from 'react';

const F: React.FC = () => {
    const { t } = useLang('ces2026.F');
    const items: ItfItem[] = [
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1765351453554/time.png',
            img: 'https://websiteoss.ecoflow.com/upload/image/1765353518534/oceanpro.png',
            label: t('item1_label'),
            name: t('item1_name'),
            text: t('item1_text'),
            btns: [{ type: 'more', url: 'https://energy.ecoflow.com/us/products/ocean-pro-home-solar-battery?ref=ces2026' }],
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1765351440242/ces.png',
            img: 'https://websiteoss.ecoflow.com/upload/image/1765353518234/dpux.png',
            label: t('item2_label'),
            name: t('item2_name'),
            text: t('item2_text'),
            btns: [
                { type: 'buy', url: 'https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781171785' },
                { type: 'more', url: 'https://www.ecoflow.com/us/delta-pro-ultra-x?ref=ces2026', target: '_self' },
            ],
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766042326295/nbc.png',
            img: 'https://websiteoss.ecoflow.com/upload/image/1765353518117/d3.png',
            label: t('item3_label'),
            name: t('item3_name'),
            text: t('item3_text'),
            btns: [
                { type: 'buy', url: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713&view=d3up' },
                { type: 'more', url: 'https://www.ecoflow.com/us/delta-3-series?ref=ces2026', target: '_self' },
            ],
        },
    ];

    const handle_GTM_107 = (item: ItfItem, btn: ItfItemBtn) => ({
        event: 'uaEvent',
        event_name: 'select_product',
        list_name: t('title'),
        product_name: item.name,
        button_name: t('btn_more'),
        __btn_id1: 'ces-2026-F',
        __btn_id2: btn.url,
        __btn_type: 'href',
    });

    const handle_GTM_108 = (item: ItfItem, btn: ItfItemBtn) => ({
        event: 'uaEvent',
        event_name: 'buy',
        product_name: item.name,
        position: 'CES-2026',
        url: btn.url,
        __btn_id1: 'ces-2026-F',
        __btn_id2: btn.url,
        __btn_type: 'href',
    });

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const scenes: any = [];
    //         const el: HTMLDivElement | null = document.querySelector('.ces-2026-E');
    //         if (el) {
    //             scenes.push(
    //                 AniContainer.create({
    //                     triggerElement: el,
    //                     triggerHook: 1,
    //                     offset: el.offsetHeight,
    //                     duration: '50%',
    //                     syncFromTo: [
    //                         ['.ces-2026-F', { y: window.innerHeight / 2 }, { y: 0 }],
    //                         ['.ces-2026-E .box2', { opacity: 1 }, { opacity: 0 }],
    //                     ],
    //                 }),
    //             );
    //         }
    //         return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
    //     }
    // }, []);

    return (
        <div id="ces-2026-F" className={`ces-2026-F ${css.section} GtmModuleData-section`} data-section-id={'ces-2026-F'}>
            <div className="box-inner">
                <div className="info">
                    <h2 className="title">{t('title')}</h2>
                </div>
                <Swiper className="items" slidesPerView={'auto'} spaceBetween={12}>
                    {items?.map((item: ItfItem, i: number) => (
                        <SwiperSlide className="item" key={i}>
                            <div className="item-img">
                                <EcoImg className="img-p" pc={item.img} />
                                <EcoImg className="img-logo" pc={item.logo} />
                            </div>
                            <div className="item-info">
                                <p className="item-label text">{item.label}</p>
                                <p className="item-name name">{item.name}</p>
                                <p className="item-text text">{item.text}</p>
                                <div className="item-btns">
                                    {item.btns?.map((btn: ItfItemBtn, j: number) => (
                                        <EcoLink
                                            className={`item-btn GtmModuleData-btn-href btn-${btn?.type}`}
                                            target={btn?.target || '_blank'}
                                            href={btn.url}
                                            key={`${i}-${j}`}
                                            dataLayer={btn.type === 'more' ? handle_GTM_107(item, btn) : handle_GTM_108(item, btn)}
                                        >
                                            {t(`btn_${btn.type}`)}
                                        </EcoLink>
                                    ))}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default F;
